<script setup>
import { toRefs } from "vue";

const props = defineProps({
  data: {
    type: Object,
    default: {},
  },
  stylesClasses: {
    type: Array,
    default: [],
  },
});

const { data } = toRefs(props);
</script>

<template>
  <div class="flex flex-col">
    <span
      v-for="(propValue, propIndex) in Object.values(data)"
      :class="stylesClasses[propIndex]"
    >
      {{ propValue }}
    </span>
  </div>
</template>
